import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import Flexbox from 'flexbox-react';
import { colorLightGrey, colorVeryLightGrey, colorBlue } from 'styles/base';

// Component styles
const page = css`
    width:100%;
    display: flex:
    flex: 1;
    flex-direction: column;
`;

const header = css`
    background-color: white;
    height: 50px;
    width:100%;
`;

const titleBox = css`
    padding-left: 15px;
    padding-top: 5px;
`;

const title = css`
    font-weight: 900;
    font-size: 14px;
`;

const formBox = css`
    flex: 1 1 auto;
    overflow-y: auto;
    height: 0px;
    background-color: ${colorVeryLightGrey};
    border: 1px solid ${colorLightGrey};
    padding: 15px 25px;
    overflow: auto;
`;

const buttonBar = css`
    justify-content: flex-end;
    align-items: center;
    padding-right:10px;
    button {
        margin: 0 2px;
    }
`;


export default class WizardPage extends React.Component {

    static propTypes = {
        title: PropTypes.string,       // the title of the page
        subPageName: PropTypes.string, // title of the subpage if exists
        name: PropTypes.string,        // the name of the wizard (e.g., process name) if it exists
        description: PropTypes.string, // the description of the page, shown in the top of the form
        data: PropTypes.object,        // the data from the wizard that the page will fill out
        onChange: PropTypes.func       // handler when any data is changed on the page;  it passes the new data and validation state
    };

    renderHeaderButtons = () => {
        return (
            <div/>
        );
    };

    /**
     * Child classes should override
     * @returns {*}
     */
    renderForm() {
        return (
            <div/>
        );
    }

    render() {
        return (
            <Flexbox className={`page-container ${page}`} flexDirection={'column'}>
                <Flexbox className={`header ${header}`} flexDirection={'row'}>
                    <Flexbox className={titleBox} flexDirection={'column'}>
                        <Flexbox className={title}>
                            {this.props.title}
                        </Flexbox>
                        <Flexbox>
                            {this.props.description}
                        </Flexbox>
                    </Flexbox>
                    <Flexbox flexDirection={'row'} flexGrow={1} className={buttonBar}>
                        {this.renderHeaderButtons()}
                    </Flexbox>
                </Flexbox>

                <Flexbox className={`rie-scrollable form-container ${formBox}`} flexGrow={1}>
                    {this.renderForm()}
                </Flexbox>
            </Flexbox>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/core/wizard/WizardPage.js